const CustomToast = () => null;
export { CustomToast };
//# sourceMappingURL=CustomToast.mjs.map
